import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../constants';
import ApiService from '../modules/api-service';

export const useMyDealer = () =>
  useQuery([QueryKeys.myDealer], () => ApiService.dealer.dealerControllerGetMyDealer().then((res) => res.data));
